// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const RegistrationProduct = t.struct({
    baseMachineCode: t.String,
    imageUrl: t.String,
    pin: t.String
}, {
    name: 'RegistrationProduct',
    strict: true
});

export const getDefaultState = () => new RegistrationProduct({
    baseMachineCode: '',
    imageUrl: '',
    pin: ''
});

export default RegistrationProduct;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/registration-product.js